import { Yup, constants } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants
const today = new Date();
today.setHours(0, 0, 0, 0);
function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )


  return Yup.object(
    {
      name: Yup.string().required(requiredMessage),
      contactName: Yup.string().matches(/^[A-Za-z]+(?:[\s'-][A-Za-z]+)*$/,
        'Name can only contain alphabets.'),
      contactPhoneNumber: Yup.string().matches(/^\+(?:\d{1,3}\-)?\d{1,14}$/, 'please enter valid telephone number'),
      contactEmail: Yup.string().email('please enter a valid email')

    })
}

export default makeValidationSchema
